import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Wagholitomumbaicabs() {



  const cardData = {


  keyword: "Wagholi to Mumbai Cabs",

  headingDescription: "Trustline Cab provides dependable Wagholi to Mumbai cab services with safe, comfortable, and affordable transportation for business travel, airport transfers, corporate meetings, family vacations, and outstation journeys. Whether you require a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups and a smooth, hassle-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is your trusted choice for Wagholi to Mumbai taxi services.",

  topPlaces: [
    {
      title: "Andheri West",
      description: "Andheri West is a vibrant commercial and entertainment district featuring corporate offices, business centers, premium hotels, shopping destinations, and excellent metro connectivity."
    },
    {
      title: "Powai",
      description: "Powai is one of Mumbai's leading business and residential localities, home to IT companies, corporate campuses, educational institutions, and modern infrastructure."
    },
    {
      title: "Ghatkopar",
      description: "Ghatkopar is a well-connected commercial hub known for business establishments, retail centers, corporate offices, and seamless access across Mumbai."
    },
    {
      title: "Santacruz",
      description: "Santacruz is an important commercial and transportation hub with corporate offices, business hotels, educational institutions, and proximity to Mumbai Airport."
    },
    {
      title: "One International Center",
      description: "One International Center in Lower Parel is a premium corporate tower housing multinational companies, financial institutions, and modern office spaces."
    },
    {
      title: "Mindspace Airoli",
      description: "Mindspace Airoli is a world-class IT and business park accommodating technology companies, multinational corporations, and financial organizations."
    },
    {
      title: "Bandra Fort",
      description: "Bandra Fort is a historic waterfront landmark offering panoramic views of the Arabian Sea and the iconic Bandra-Worli Sea Link."
    },
    {
      title: "Juhu Beach",
      description: "Juhu Beach is one of Mumbai's most popular beaches, famous for its lively atmosphere, street food, and beautiful sunset views."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is an impressive meditation monument known for its magnificent dome, peaceful surroundings, and spiritual significance."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is one of India's oldest aquariums, featuring a diverse collection of marine life and interactive exhibits for visitors."
    }
  ],






 "services": [
    {
      "name": "Wagholi to Mumbai Cab",
      "description": "Book Wagholi to Mumbai cab for safe, comfortable, and affordable outstation travel with professional drivers and clean AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for one-way, round-trip, airport transfers, business travel, and family trips with doorstep pickup and transparent pricing."
    },
    {
      "name": "Wagholi to Mumbai Taxi",
      "description": "Hire Wagholi to Mumbai taxi service with experienced chauffeurs, premium AC vehicles, and affordable fares for airport transfers, corporate travel, and family journeys."
    },
    {
      "name": "Wagholi to Mumbai Cab Service",
      "description": "Our Wagholi to Mumbai cab service provides reliable one-way and round-trip taxi bookings with punctual pickup, sanitized vehicles, professional drivers, and 24x7 customer support."
    },
    {
      "name": "Wagholi to Mumbai Taxi Service",
      "description": "Travel comfortably with Wagholi to Mumbai taxi service offering transparent pricing, well-maintained vehicles, and flexible travel options for business and leisure."
    },
    {
      "name": "Wagholi to Mumbai Cab Price",
      "description": "Check Wagholi to Mumbai cab price with transparent fares for Sedan, Ertiga, Innova Crysta, and SUV vehicles without hidden charges."
    },
    {
      "name": "Wagholi to Mumbai Airport Cab",
      "description": "Book Wagholi to Mumbai Airport cab for timely airport transfers with experienced chauffeurs, spacious luggage capacity, and comfortable long-distance travel."
    },
    {
      "name": "Wagholi to Mumbai Airport Cab Service",
      "description": "Choose Wagholi to Mumbai Airport cab service for reliable airport pickup and drop with professional drivers, AC vehicles, and on-time service."
    },
    {
      "name": "Mumbai to Wagholi Cab Service",
      "description": "Book Mumbai to Wagholi cab service for comfortable return travel with doorstep pickup, clean vehicles, and experienced drivers."
    },
    {
      "name": "Kharadi to Mumbai Airport Cab Service",
      "description": "Hire Kharadi to Mumbai Airport cab service for convenient airport transfers with reliable drivers, comfortable cars, and affordable pricing."
    },
    {
      "name": "Kharadi to Mumbai Airport Cab Service Rates",
      "description": "Check Kharadi to Mumbai Airport cab service rates with transparent pricing for Sedan, Ertiga, Innova Crysta, and premium SUV cabs."
    },
    {
      "name": "Lohegaon to Mumbai Airport Cab",
      "description": "Book Lohegaon to Mumbai Airport cab for safe and punctual airport transportation with professional chauffeurs and comfortable vehicles."
    },
    {
      "name": "Perne Phata to Mumbai Airport Cab",
      "description": "Choose Perne Phata to Mumbai Airport cab for reliable airport transfers with affordable fares and experienced drivers."
    },
    {
      "name": "Kesnand to Mumbai Cab Service",
      "description": "Book Kesnand to Mumbai cab service for comfortable outstation travel with AC vehicles, transparent pricing, and professional drivers."
    },
    {
      "name": "Uruli Kanchan to Mumbai Cabs Service",
      "description": "Hire Uruli Kanchan to Mumbai cab service for business travel, family trips, airport transfers, and one-way or round-trip journeys."
    },
    {
      "name": "Mundwa to Mumbai Cabs Service",
      "description": "Book Mundwa to Mumbai cab service with reliable drivers, premium vehicles, and affordable outstation taxi fares."
    },
    {
      "name": "Manjari to Mumbai Cabs Service",
      "description": "Choose Manjari to Mumbai cab service for convenient airport transfers, family travel, and business trips with comfortable AC cars."
    },
    {
      "name": "Pune Nagar Road to Mumbai Cabs Service",
      "description": "Book Pune Nagar Road to Mumbai cab service with professional chauffeurs, clean vehicles, and reliable outstation transportation."
    },
    {
      "name": "Cab Service in Wagholi",
      "description": "Cab service in Wagholi offers local taxi, airport transfers, railway station pickup, corporate travel, and outstation cabs with experienced drivers and well-maintained AC vehicles."
    },
    {
      "name": "Cab Service in Wagholi Pune",
      "description": "Reliable cab service in Wagholi Pune providing local and outstation taxi booking, airport transfers, and corporate transportation at affordable prices."
    },
    {
      "name": "Innova Crysta on Rent in Wagholi",
      "description": "Hire Innova Crysta on rent in Wagholi for luxury family trips, airport transfers, business travel, and premium outstation journeys."
    },
    {
      "name": "Ertiga on Rent in Wagholi",
      "description": "Book Ertiga on rent in Wagholi for affordable 6 to 7 seater travel with comfortable seating, airport transfers, and family tours."
    },
    {
      "name": "Sedan Cabs on Rent in Wagholi",
      "description": "Choose Sedan cabs on rent in Wagholi for economical business travel, airport pickups, local rides, and outstation taxi services."
    },
    {
      "name": "Wagholi to Mumbai Cab Booking",
      "description": "Book Wagholi to Mumbai cab online with instant confirmation, multiple vehicle options, transparent fares, and dedicated customer support."
    },
    {
      "name": "Cab from Wagholi to Mumbai",
      "description": "Hire a private cab from Wagholi to Mumbai with experienced chauffeurs, clean vehicles, and comfortable long-distance travel."
    },
    {
      "name": "Wagholi to Mumbai Car Rental",
      "description": "Choose Wagholi to Mumbai car rental service with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles for flexible travel."
    },
    {
      "name": "Wagholi to Mumbai One Way Cabs",
      "description": "Book Wagholi to Mumbai one way cabs for affordable single-side travel without paying return charges."
    },
    {
      "name": "Cheap Wagholi to Mumbai Cabs",
      "description": "Get cheap Wagholi to Mumbai cabs with budget-friendly pricing, professional drivers, and comfortable AC vehicles."
    },
    {
      "name": "Wagholi to Mumbai Taxi Fare",
      "description": "Check Wagholi to Mumbai taxi fare with transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV vehicles."
    },
    {
      "name": "Book Wagholi to Mumbai Cab Online",
      "description": "Reserve Wagholi to Mumbai cab online through an easy booking process with instant confirmation and trusted taxi service."
    },
    {
      "name": "Wagholi to Mumbai Outstation Cab",
      "description": "Travel safely with Wagholi to Mumbai outstation cab service featuring experienced drivers, clean vehicles, and comfortable highway journeys."
    },
    {
      "name": "24x7 Wagholi to Mumbai Taxi Service",
      "description": "24x7 Wagholi to Mumbai taxi service is available anytime for airport transfers, emergency travel, business trips, and family transportation."
    },
    {
      "name": "Best Wagholi to Mumbai Cab Service",
      "description": "Choose the best Wagholi to Mumbai cab service for premium travel experience with affordable fares, reliable drivers, well-maintained vehicles, and excellent customer support."
    }
  ],

  "tableData": [
    ["Wagholi to Mumbai Cab", "Wagholi to Mumbai Taxi"],
    ["Wagholi to Mumbai Cab Service", "Wagholi to Mumbai Taxi Service"],
    ["Wagholi to Mumbai Cab Price", "Wagholi to Mumbai Airport Cab"],
    ["Wagholi to Mumbai Airport Cab Service", "Mumbai to Wagholi Cab Service"],
    ["Kharadi to Mumbai Airport Cab Service", "Kharadi to Mumbai Airport Cab Service Rates"],
    ["Lohegaon to Mumbai Airport Cab", "Perne Phata to Mumbai Airport Cab"],
    ["Kesnand to Mumbai Cab Service", "Uruli Kanchan to Mumbai Cabs Service"],
    ["Mundwa to Mumbai Cabs Service", "Manjari to Mumbai Cabs Service"],
    ["Pune Nagar Road to Mumbai Cabs Service", "Cab Service in Wagholi"],
    ["Cab Service in Wagholi Pune", "Innova Crysta on Rent in Wagholi"],
    ["Ertiga on Rent in Wagholi", "Sedan Cabs on Rent in Wagholi"],
    ["Wagholi to Mumbai Cab Booking", "Cab from Wagholi to Mumbai"],
    ["Wagholi to Mumbai Car Rental", "Wagholi to Mumbai One Way Cabs"],
    ["Cheap Wagholi to Mumbai Cabs", "Wagholi to Mumbai Taxi Fare"],
    ["Book Wagholi to Mumbai Cab Online", "Wagholi to Mumbai Outstation Cab"],
    ["24x7 Wagholi to Mumbai Taxi Service", "Best Wagholi to Mumbai Cab Service"]
  ],





whychoose: [
  {
    WhyChooseheading: "Trusted Wagholi to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Travels offers reliable Wagholi to Mumbai cab services with comfortable vehicles for business travel, airport transfers, and family trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Wagholi",
    WhyChoosedescription: "We provide convenient pickup from Wagholi, Kesnand Road, Kharadi, Lohegaon, Chandan Nagar, and nearby Pune areas."
  },
  {
    WhyChooseheading: "Experienced Drivers for Expressway Travel",
    WhyChoosedescription: "Our professional chauffeurs ensure a safe, comfortable, and timely journey through the Pune-Mumbai Expressway."
  },
  {
    WhyChooseheading: "Transparent & Affordable Pricing",
    WhyChoosedescription: "Book your cab with confidence through competitive fares, upfront pricing, and no hidden charges."
  },
  {
    WhyChooseheading: "Vehicle Options for Every Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for solo travelers, families, and groups."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "Select one-way cabs, return journeys, or customized outstation travel packages based on your convenience."
  },
  {
    WhyChooseheading: "Ideal for Airport & Corporate Transfers",
    WhyChoosedescription: "Our services are perfect for Mumbai Airport transfers, office travel, hotel transfers, and business meetings."
  },
  {
    WhyChooseheading: "Fast Booking & 24/7 Customer Support",
    WhyChoosedescription: "Receive instant quotations, quick booking confirmation, and round-the-clock assistance from our travel experts."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Wagholi to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers dependable Wagholi to Mumbai cab services for one-way travel, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Wagholi to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with convenient doorstep pickup from Wagholi."
  },
  {
    question: "Which vehicles are available for Wagholi to Mumbai travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit different travel requirements."
  },
  {
    question: "Do you provide pickup from nearby Wagholi locations?",
    answer: "Yes, pickup is available from Wagholi, Kesnand Road, Chandan Nagar, Kharadi, Lohegaon, and surrounding areas."
  },
  {
    question: "Can I book a cab from Wagholi to Mumbai Airport?",
    answer: "Yes, we provide direct cab transfers from Wagholi to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable state taxes are generally charged separately unless specified during booking."
  },
  {
    question: "Is Wagholi to Mumbai cab service available 24 hours?",
    answer: "Yes, Trustline Travels operates 24/7 to provide cab services at your preferred travel time."
  },
  {
    question: "Can I pre-book my cab before the travel date?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup schedule."
  },
  {
    question: "Do you provide cabs for business and family travel?",
    answer: "Yes, our Wagholi to Mumbai cab service is suitable for corporate travel, family vacations, airport transfers, and leisure trips."
  },
  {
    question: "How can I book a Wagholi to Mumbai cab with Trustline Travels?",
    answer: "Share your pickup address, destination, travel date, and preferred vehicle details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Pawar",
    feedback: "Trustline Travels made my Wagholi to Mumbai journey completely stress-free. The cab was clean, the driver was courteous, and the trip was completed comfortably and on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Desai",
    feedback: "We booked a cab from Wagholi to Mumbai for our family, and the overall experience was excellent. The vehicle was spacious, the booking process was simple, and the service was highly professional.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wagholi to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/wagholi-to-mumbai-cab.webp",
  "description": "Book Wagholi to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, airport transfers, and private taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5264"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/wagholi-to-mumbai-cab"
  }
};



  return (
    <div>
<Helmet>
  <title>Wagholi to Mumbai Cab | Airport Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Wagholi to Mumbai cab service with Trustline Travels for reliable one-way, round-trip, and airport transfers. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Wagholi to mumbai cab price, Wagholi to Mumbai Cab, wagholi to mumbai airport cab service, mumbai to wagholi cab service, kharadi to mumbai airport cab service, Kharadi to mumbai airport cab service rates, lohegaon to mumbai airport cab, perne phata to mumbai airport cab, kesnand to mumbai cab service, uruli kanchan to mumbai cabs service, wagholi to mumbai taxi, wagholi to mumbai one way cab, wagholi mumbai airport taxi, wagholi to mumbai innova cab, wagholi to mumbai ertiga cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<Helmet>
  <title>Wagholi to Mumbai Cab | Airport Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Wagholi to Mumbai cab service with Trustline Travels for reliable one-way, round-trip, and airport transfers. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Wagholi to mumbai cab price, Wagholi to Mumbai Cab, wagholi to mumbai airport cab service, mumbai to wagholi cab service, kharadi to mumbai airport cab service, Kharadi to mumbai airport cab service rates, lohegaon to mumbai airport cab, perne phata to mumbai airport cab, kesnand to mumbai cab service, uruli kanchan to mumbai cabs service, wagholi to mumbai taxi, wagholi to mumbai one way cab, wagholi mumbai airport taxi, wagholi to mumbai innova cab, wagholi to mumbai ertiga cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Wagholitomumbaicabs;